module.exports = __webpack_public_path__ + "static/popup-70377ca7a5f124344a8053fb3d3ecbce.jpg";